import { useState } from 'react'
import { fbt } from 'fbtee'
import { Sparkles } from 'lucide-react'
import { CountBadge } from '../../components/CountBadge'
import { WhatsNewDialog } from '../../components/WhatsNewDialog'
import { useWhatsNew } from '../../hooks/useWhatsNew'
import { track } from '../../lib/analytics'
import { recentDigest, type Digest } from '../../lib/whatsNew'
import { SettingsLinkRow } from './SettingsSection'

/** Permanent entry to the What's new dialog: the latest entries, seen or not. Hidden while the rollout gate in `useWhatsNew` is closed. */
export function WhatsNewSettingsRow() {
  const { entries, ready, unseenCount, markSeen } = useWhatsNew()
  const [openDigest, setOpenDigest] = useState<Digest | null>(null)

  if (!ready || entries.length === 0) return null

  function open() {
    const digest = recentDigest(entries)
    setOpenDigest(digest)
    markSeen()
    track('whats_new_opened', { kind: digest.mode, item_count: digest.entries.length })
  }

  return (
    <>
      <SettingsLinkRow
        icon={<Sparkles className="size-4" />}
        label={fbt("What's new", "Row in Settings that opens the list of recent app features")}
        badge={<CountBadge count={unseenCount} />}
        onClick={open}
        testId="settings-whats-new-row"
      />
      <WhatsNewDialog
        open={openDigest !== null}
        onOpenChange={next => {
          if (!next) setOpenDigest(null)
        }}
        digest={openDigest ?? undefined}
        description={fbt('Recent updates to Faro', "Subtitle of the What's new dialog opened from Settings, listing the latest features")}
      />
    </>
  )
}
